import { Checkbox } from '@porterin/component-library/src/base-components';
import React from 'react';
import { UseFormRegister, UseFormTrigger } from 'react-hook-form';
import { FormData } from './FareEstimateValidationSchema';

export interface CallbackConsentCheckboxProps {
  label: string;
  should_show: boolean;
  form: {
    register: UseFormRegister<FormData>;
    trigger: UseFormTrigger<FormData>;
  };
  class_name?: string;
}

export const CallbackConsentCheckbox: React.FC<
  CallbackConsentCheckboxProps
> = ({ label, class_name = '', form, should_show }) => {
  const { register, trigger } = form;
  const inputId = `consentForCallback-${React.useId()}`;

  return should_show ? (
    <Checkbox
      identifiers={{ id: inputId }}
      checkboxOptions={{
        label: label,
        value: '',
        labelClass: 'normal-case -mt-[0.4rem] text-[1.4rem]',
      }}
      className={class_name}
      {...register('consentForCallback', {
        onChange: _e => {
          trigger('consentForCallback');
        },
      })}
    />
  ) : null;
};

export default CallbackConsentCheckbox;
